import React from 'react';

function EmptySpace() {
  return (<span>&nbsp;&nbsp;</span>)
}

export default EmptySpace;